import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import { joinClasses } from 'utils/utils';
import { Arrows } from 'helpers/quizIcons';
import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	constructor(props) {
		super(props);
		this.toggleQuizFooter = this.toggleQuizFooter.bind(this);
	}

	toggleQuizFooter() {
		this.setState({
			quizFooterOpen: !this.state.quizFooterOpen
		});
	}

	renderOpener() {
		const { quizFooterOpen } = this.state;
		const copy = this.props?.store?.appData?.copy?.baseCopy || {};

		return (
			<div class={joinClasses(s.quizFooterOpener, !quizFooterOpen && s.closed)}>
				<button onClick={this.toggleQuizFooter} class={s.quizFooterToggle}>
					<Arrows />
					<span>{copy.$FOOTER_CTA}</span>
				</button>
			</div>
		);

	}

	render(props, state) {
		if (props?.store?.activePage === 'admissionsQuiz') {
			const { quizFooterOpen } = this.state;
			const base = super.render(props, state);
			base.attributes.class += ` ${joinClasses(s.quizFooter, !quizFooterOpen && s.closed)}`;
			const opener = this.renderOpener();
			base.children.unshift(opener);
			return base;
		}

		return super.render(props, state);
	}
}
